import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { HomeTypeParams } from './service';

export enum HomeTypeActions {
  Failure = '[Catalogs HomeType] Failure',
  Request = '[Catalogs HomeType] Request',
  Success = '[Catalogs HomeType] Success',
}

export const HomeTypeFailure = createAction(HomeTypeActions.Failure, props<{ error: HttpErrorResponse }>());

export const HomeTypeRequest = createAction(HomeTypeActions.Request, props<{ parameters: HomeTypeParams }>());

export const HomeTypeSuccess = createAction(HomeTypeActions.Success, props<{ data: ParameterResult }>());
